import * as actions from "../actions/notificationActions"

const initialState = {
    message: '',
    showNotification: false,
    itemRemovedNotification: false,
    loadingProject: false
};

export const notificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SHOW_NOTIFICATION:
            return {
                ...state,
                showNotification: true,
                message: action.message
            };
        case actions.HIDE_NOTIFICATION:
            return {
                ...state,
                showNotification: false
            };
        case actions.ITEM_REMOVED_NOTIFIED:
            return {
                ...state,
                itemRemovedNotification: true
            };
        case actions.LOADING_PROJECT_MESSAGE:
            return {
                ...state,
                loadingProject: action.loadingProject
            };
        default:
            return state
    }
};


